import { action, makeObservable, observable } from "mobx";
import { AppStoreApi } from "./AppStore";

export class MainWindowStore {
  root: AppStoreApi;
  showRegistration = false;
  showUserLogin = false;
  showStudentLogin = false;
  showPasswordReset = false;

  constructor(root: AppStoreApi) {
    this.root = root;

    makeObservable(this, {
      showRegistration: observable,
      onRegistrationOpen: action.bound,
      onRegistrationClose: action.bound,
      showUserLogin: observable,
      onUserLoginOpen: action.bound,
      onUserLoginClose: action.bound,
      showStudentLogin: observable,
      onStudentLoginOpen: action.bound,
      showPasswordReset: observable,
      onPasswordResetOpen: action.bound,
      onPasswordResetClose: action.bound,
    });
  }

  onRegistrationOpen = () => {
    this.showRegistration = true;
  };

  onRegistrationClose = () => {
    this.showRegistration = false;
  };

  onUserLoginOpen = () => {
    this.showUserLogin = true;
  };

  onUserLoginClose = () => {
    this.showUserLogin = false;
  };

  onStudentLoginOpen = () => {
    this.showStudentLogin = true;
  };

  onStudentLoginClose = () => {
    this.showStudentLogin = false;
  };

  onPasswordResetOpen = () => {
    this.showRegistration = false;
    this.showUserLogin = false;
    this.showStudentLogin = false;
    this.showPasswordReset = true;
  };

  onPasswordResetClose = () => {
    this.showPasswordReset = false;
  };
}
